import { isNcl } from "utils/app/utils";

// Checks if NCL mode is enabled
// Converts project-related scope keys to fleet-related keys
// Returns the transformed key or the original key

export function getScopeType(localizationKey) {
    if (isNcl()) {
        const localizedScopeKey = localizationKey.replace(/projects/g, 'fleets')
            .replace(/project/g, 'fleet')
            .replace(/pros/g, 'fleets')
            .replace(/pro/g, 'fleet')
            .replace(/Project/g, 'Fleet');
        return localizedScopeKey ;
    }
    return localizationKey;
}